import React, { useState, useEffect, useRef } from "react";
import {
  Modal,
  ModalBody,
  ModalHeader,
  Row,
  Col,
  Label,
  Input,
  Button,
} from "reactstrap";
// componentes
import ColorPicker from "../../../components/ColorPicker/ColorPicker";
import ButtonSpinner from "../../../components/Buttons/ButtonSpinner";
// editor de texto
import TextEditor from "../Match/TextEditor";
// select
import Select from "react-select";
// alerta
import SweetAlert from "react-bootstrap-sweetalert";
// desc
import UploadComponent from "../../Apps/Personalization/UploadComponent";
// service
import {
  getConfigQrCode,
  createConfigQrCode,
} from "../../../utils/services/configQrcode";
import { getUrlFiles } from "../../../utils/services/files";
// moment
import moment from "moment";

export default function ModalConfig(props) {
  const { isOpen, toggle, idEvent } = props;
  // carregamento
  const [loading, setLoading] = useState(true);
  // carregamento
  const [loadingBtn, setLoadingBtn] = useState(false);
  // erros
  const [errors, setErrors] = useState(false);
  // alerta
  const [success, setSuccess] = useState(false);
  // tipo de requisição
  const [typeRequest, setTypeRequest] = useState("post");
  // form
  const [colorBg, setColorBg] = useState("#ffffff");
  const [colorBtn, setColorBtn] = useState("#ffffff");
  const [imageBackground, setImageBackground] = useState("");
  const [imageBackgroundView, setImageBackgroundView] = useState();
  const [qrcodeList, setQrcodeList] = useState(true);
  const [dataLimit, setDataLimit] = useState(false);
  const [dateStart, setDateStart] = useState(null);
  const [dateEnd, setDateEnd] = useState(null);
  const [buttonName, setButtonaName] = useState("");
  const [modalContent, setModalContent] = useState("");
  const [id, setId] = useState(null);
  // editor de texto
  const refModalContent = useRef(null);

  async function verifyForm() {
    setLoadingBtn(true);

    if (!imageBackground && !imageBackgroundView) {
      setErrors({
        image: "O campo Imagem é obrigatório",
      });
      setLoadingBtn(false);
      return;
    } else setErrors({ image: "" });

    if (dataLimit && !dateStart) {
      setErrors({
        dateStart: "O campo Data e Hora Inicio é obrigatório",
      });
      setLoadingBtn(false);
      return;
    } else setErrors({ dateStart: "" });

    if (dataLimit && !dateEnd) {
      setErrors({
        dateEnd: "O campo Data e Hora Fim é obrigatório",
      });
      setLoadingBtn(false);
      return;
    } else setErrors({ dateEnd: "" });

    if (dataLimit && dateStart > dateEnd) {
      setErrors({
        dateEnd:
          "A Data e Hora Fim não pode ser menor que a Data e Hora Inicio.",
      });
      setLoadingBtn(false);
      return;
    } else setErrors({ dateEnd: "" });

    if (!buttonName && refModalContent.current.getContent()) {
      setErrors({
        buttonName: "O campo Nome do botão é obrigatório",
      });
      setLoadingBtn(false);
      return;
    } else setErrors({ buttonName: "" });

    if (buttonName && !refModalContent.current.getContent()) {
      setErrors({
        modalContent: "O campo Conteúdo do modal é obrigatório",
      });
      setLoadingBtn(false);
      return;
    } else setErrors({ modalContent: "" });

    var urlImageBackground = imageBackgroundView;

    var dataImg = new FormData();

    var haveImg = false;

    if (imageBackground && imageBackground?.files[0]) {
      dataImg.append("files", imageBackground.files[0]);
      haveImg = true;
    }

    if (haveImg) {
      try {
        const res = await getUrlFiles(dataImg);

        urlImageBackground = res[0].url;
      } catch (error) {
        console.log("img erro", error);
      }
    }

    const data = {
      eventId: idEvent,
      backgroundColor: colorBg,
      buttonColor: colorBtn,
      image: urlImageBackground,
      limitByPeriod: dataLimit,
      startDate: dataLimit ? new Date(dateStart) : null,
      endDate: dataLimit ? new Date(dateEnd) : null,
      showQrcodeList: qrcodeList,
      buttonName: buttonName,
      content: refModalContent.current.getContent(),
    };

    await createConfigQrCode(data, typeRequest, id)
      .then((res) => {
        if (res.data.message === "UPDATED" || res.data.message === "CREATED") {
          setLoadingBtn(false);
          setSuccess(true);
        }
      })
      .catch((error) => {
        console.log("erro", error);
        setLoading(false);
      });
  }

  async function getConfig() {
    await getConfigQrCode(idEvent)
      .then((res) => {
        if (res.data.total && res.data.total > 0) {
          const data = res.data.data[0];

          setColorBg(data.backgroundColor);
          setColorBtn(data.buttonColor);
          setImageBackgroundView(data.image);
          setQrcodeList(data.showQrcodeList);
          setDataLimit(data.limitByPeriod);
          setDateStart(
            data.limitByPeriod
              ? moment(data.startDate).format().replace("-03:00", "")
              : ""
          );
          setDateEnd(
            data.limitByPeriod
              ? moment(data.endDate).format().replace("-03:00", "")
              : ""
          );
          setButtonaName(data.buttonName);
          setModalContent(data.content);
          setId(data.id);

          setTypeRequest("put");
        }
      })
      .catch((error) => console.log("erro", error));

    setLoading(false);
  }

  useEffect(() => {
    getConfig();
  }, []);

  return (
    <>
      {success && (
        <SweetAlert
          success
          title={"Concluído"}
          onConfirm={() => {
            setSuccess(false);
            toggle();
          }}
        >
          {"Configurações salvas com sucesso!"}
        </SweetAlert>
      )}
      <Modal isOpen={isOpen} centered>
        <ModalHeader toggle={toggle}>Configurações</ModalHeader>
        <ModalBody>
          {loading ? (
            <p style={{ textAlign: "center" }}>Carregando ...</p>
          ) : (
            <>
              <Row>
                <Col md={12}>
                  <ColorPicker
                    classOfContainer="primary-card-pickr"
                    labelText="Cor de Fundo"
                    setStateFunc={setColorBg}
                    defaultColor={colorBg}
                    idDiv="bgColor"
                  />
                </Col>
              </Row>
              <Row style={{ marginTop: 10 }}>
                <Col md={12}>
                  <ColorPicker
                    classOfContainer="secundary-card-pickr"
                    labelText="Cor do Botão"
                    setStateFunc={setColorBtn}
                    defaultColor={colorBtn}
                    idDiv="btnColor"
                  />
                </Col>
              </Row>
              <Row style={{ marginTop: 10 }}>
                <Col md={imageBackgroundView && !imageBackground ? 6 : 12}>
                  {/* <Label htmlFor="formFile" className="form-label">
                    Imagem*
                  </Label> */}
                  <UploadComponent
                    id="formFile"
                    labelText="Imagem*"
                    setStateFunc={setImageBackground}
                    tipText="Tamanho 500x500"
                  />
                  {errors && errors.image && (
                    <a style={{ color: "red" }}>{errors.image}</a>
                  )}
                </Col>

                {imageBackgroundView && !imageBackground && (
                  <Col md={6}>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    >
                      <img
                        src={imageBackgroundView}
                        style={{ width: 100, height: 100 }}
                      />
                      <i
                        className="mdi mdi-trash-can icon-trash"
                        onClick={() => {
                          setImageBackgroundView(null);
                          setImageBackground(null);
                        }}
                      />
                    </div>
                  </Col>
                )}
              </Row>
              <Row>
                <Col md={12}>
                  <label className="form-label">Exibir Lista de QR Codes</label>
                  <Select
                    placeholder={"Selecione"}
                    defaultValue={
                      qrcodeList
                        ? { label: "Sim", value: true }
                        : { label: "Não", value: false }
                    }
                    onChange={(e) => setQrcodeList(e.value)}
                    options={[
                      {
                        options: [
                          { label: "Não", value: false },
                          { label: "Sim", value: true },
                        ],
                      },
                    ]}
                    classNamePrefix="select2-selection"
                  />
                </Col>
              </Row>
              <Row style={{ marginTop: 10 }}>
                <Col md={12}>
                  <label className="form-label">Limitar por período</label>
                  <Select
                    placeholder={"Selecione"}
                    defaultValue={
                      dataLimit
                        ? { label: "Sim", value: true }
                        : { label: "Não", value: false }
                    }
                    onChange={(e) => {
                      setDataLimit(e.value);
                    }}
                    options={[
                      {
                        options: [
                          { label: "Não", value: false },
                          { label: "Sim", value: true },
                        ],
                      },
                    ]}
                    classNamePrefix="select2-selection"
                  />
                </Col>
              </Row>
              {dataLimit && (
                <>
                  <Row style={{ marginTop: 10 }}>
                    <Col md={6}>
                      <label className="form-label">Data e Hora Inicio*</label>
                      <input
                        className="form-control"
                        type="datetime-local"
                        defaultValue={dateStart}
                        max={dateEnd ? dateEnd : ""}
                        onChange={(e) => setDateStart(e.target.value)}
                      />
                      {errors && errors.dateStart && (
                        <a style={{ color: "red" }}>{errors.dateStart}</a>
                      )}
                    </Col>

                    <Col md={6}>
                      <label className="form-label">Data e Hora Fim*</label>
                      <input
                        className="form-control"
                        type="datetime-local"
                        defaultValue={dateEnd}
                        onChange={(e) => setDateEnd(e.target.value)}
                        min={dateStart ? dateStart : ""}
                      />
                      {errors && errors.dateEnd && (
                        <a style={{ color: "red" }}>{errors.dateEnd}</a>
                      )}
                    </Col>
                  </Row>
                </>
              )}
              <ModalHeader style={{ padding: "20px 0 10px" }}>
                Modal Instruções
              </ModalHeader>
              <Row style={{ marginTop: 10 }}>
                <Col md={12}>
                  <label className="form-label">Nome do botão</label>
                  <input
                    className="form-control"
                    type="text"
                    defaultValue={buttonName}
                    onChange={(e) => setButtonaName(e.target.value)}
                  />
                  {errors && errors.buttonName && (
                    <a style={{ color: "red" }}>{errors.buttonName}</a>
                  )}
                </Col>
              </Row>
              <Row style={{ marginTop: 10 }}>
                <Col md={12}>
                  <label className="form-label">Conteúdo do modal</label>
                  <TextEditor
                    refState={refModalContent}
                    defaultState={modalContent}
                  />
                  {errors && errors.modalContent && (
                    <a style={{ color: "red" }}>{errors.modalContent}</a>
                  )}
                </Col>
              </Row>
              <Row>
                <Col
                  md={12}
                  style={{
                    width: "100%",
                    marginTop: 20,
                    display: "flex",
                    justifyContent: "flex-end",
                  }}
                >
                  {" "}
                  <Button
                    color="danger"
                    style={{ width: 80 }}
                    onClick={() => toggle()}
                  >
                    Fechar
                  </Button>
                  <ButtonSpinner
                    isLoading={loadingBtn}
                    title={"Salvar"}
                    marginLeft={10}
                    onClick={() => verifyForm()}
                  />
                </Col>
              </Row>
            </>
          )}
        </ModalBody>
      </Modal>
    </>
  );
}
